/*
  Restyles inline Shopify Forms (the Contact page form) to match the store: pill inputs and button,
  first and last name side by side, wider on desktop, taller message box.

  The app draws its form inside an open shadow root, which theme CSS can't reach, so this adds a
  <style> inside it. The app's class names are generated (e.g. _formInputField_1quli_7), so the rules
  use field ids, element types and [class*="_name_"] matches that survive app updates.
  Theme CSS variables (radius) inherit through the shadow boundary.
*/
(() => {
  const STYLE_ID = 'nb-shopify-forms-style';
  const CSS = `
    section[class*="_formContainer_"] {
      max-width: 78rem !important;
      width: 100%;
    }

    form {
      flex-flow: row wrap !important;
    }

    form > * {
      flex: 1 1 100%;
    }

    form > div:has(> #first_name),
    form > div:has(> #last_name) {
      flex: 1 1 calc(50% - 6px) !important;
      width: auto !important;
      min-width: 0;
    }

    input[class*="_formInputField_"],
    button[class*="_selectToggle_"],
    button[type="submit"] {
      border-radius: var(--inputs-radius-outset, 40px) !important;
    }

    input[class*="_formInputField_"] {
      padding-left: 20px !important;
      padding-right: 20px !important;
    }

    label[id^="label-"] {
      left: 20px !important;
    }

    button[class*="_selectToggle_"] {
      padding-left: 20px !important;
      padding-right: 20px !important;
    }

    textarea[class*="_textArea_"] {
      box-sizing: border-box;
      min-height: 194px;
      padding-left: 20px !important;
      padding-right: 20px !important;
      border-radius: 24px !important;
    }

    /* White strip the app puts behind the "Message" label: round it to the box and keep it inside the outline */
    div:has(> textarea[class*="_textArea_"])::before {
      top: 1px;
      left: 1px;
      width: calc(100% - 26px) !important;
      border-radius: 23px 0 0 0;
    }

    button[type="submit"] {
      flex: 1 1 100% !important;
      font-weight: 700 !important;
      letter-spacing: 0.1rem;
    }

    @media screen and (max-width: 749px) {
      section[class*="_formContainer_"] {
        max-width: none !important;
      }
    }
  `;

  const style = (root) => {
    if (!root || root.getElementById(STYLE_ID)) return;
    const el = document.createElement('style');
    el.id = STYLE_ID;
    el.textContent = CSS;
    root.appendChild(el);
  };

  const watch = (embed) => {
    if (embed.dataset.nbStyled) return;
    const tryStyle = () => {
      if (!embed.shadowRoot) return false;
      style(embed.shadowRoot);
      // The app may redraw its contents; put the style back if it goes
      new MutationObserver(() => style(embed.shadowRoot)).observe(embed.shadowRoot, { childList: true });
      embed.dataset.nbStyled = 'true';
      return true;
    };
    if (tryStyle()) return;
    const timer = setInterval(() => tryStyle() && clearInterval(timer), 200);
    setTimeout(() => clearInterval(timer), 15000);
  };

  // Only pages with an inline form need this; the app adds its embed element after load
  if (!document.querySelector('[data-form-root]')) return;
  const scan = () => document.querySelectorAll('[data-form-root] shopify-forms-embed').forEach(watch);
  scan();
  const observer = new MutationObserver(scan);
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => observer.disconnect(), 15000);
})();
